// node_modules/.pnpm/@lit+context@1.1.6/node_modules/@lit/context/lib/context-request-event.js
var s = class extends Event {
  constructor(s4, t2, e3, o) {
    super("context-request", { bubbles: true, composed: true }), this.context = s4, this.contextTarget = t2, this.callback = e3, this.subscribe = o ?? false;
  }
};

// node_modules/.pnpm/@lit+context@1.1.6/node_modules/@lit/context/lib/create-context.js
function n(n2) {
  return n2;
}

// node_modules/.pnpm/@lit+context@1.1.6/node_modules/@lit/context/lib/controllers/context-consumer.js
var s2 = class {
  constructor(t2, s4, i2, h) {
    if (this.subscribe = false, this.provided = false, this.value = void 0, this.t = (t3, s5) => {
      this.unsubscribe && (this.unsubscribe !== s5 && (this.provided = false, this.unsubscribe()), this.subscribe || this.unsubscribe()), this.value = t3, this.host.requestUpdate(), this.provided && !this.subscribe || (this.provided = true, this.callback && this.callback(t3, s5)), this.unsubscribe = s5;
    }, this.host = t2, void 0 !== s4.context) {
      const t3 = s4;
      this.context = t3.context, this.callback = t3.callback, this.subscribe = t3.subscribe ?? false;
    } else this.context = s4, this.callback = i2, this.subscribe = h ?? false;
    this.host.addController(this);
  }
  hostConnected() {
    this.dispatchRequest();
  }
  hostDisconnected() {
    this.unsubscribe && (this.unsubscribe(), this.unsubscribe = void 0);
  }
  dispatchRequest() {
    this.host.dispatchEvent(new s(this.context, this.host, this.t, this.subscribe));
  }
};

// node_modules/.pnpm/@lit+context@1.1.6/node_modules/@lit/context/lib/value-notifier.js
var s3 = class {
  get value() {
    return this.o;
  }
  set value(s4) {
    this.setValue(s4);
  }
  setValue(s4, t2 = false) {
    const i2 = t2 || !Object.is(s4, this.o);
    this.o = s4, i2 && this.updateObservers();
  }
  constructor(s4) {
    this.subscriptions = /* @__PURE__ */ new Map(), this.updateObservers = () => {
      for (const [s5, { disposer: t2 }] of this.subscriptions) s5(this.o, t2);
    }, void 0 !== s4 && (this.value = s4);
  }
  addCallback(s4, t2, i2) {
    if (!i2) return void s4(this.value);
    this.subscriptions.has(s4) || this.subscriptions.set(s4, { disposer: () => {
      this.subscriptions.delete(s4);
    }, consumerHost: t2 });
    const { disposer: h } = this.subscriptions.get(s4);
    s4(this.value, h);
  }
  clearCallbacks() {
    this.subscriptions.clear();
  }
};

// node_modules/.pnpm/@lit+context@1.1.6/node_modules/@lit/context/lib/controllers/context-provider.js
var e = class extends Event {
  constructor(t2, s4) {
    super("context-provider", { bubbles: true, composed: true }), this.context = t2, this.contextTarget = s4;
  }
};
var i = class extends s3 {
  constructor(s4, e3, i2) {
    super(void 0 !== e3.context ? e3.initialValue : i2), this.onContextRequest = (t2) => {
      if (t2.context !== this.context) return;
      const s5 = t2.contextTarget ?? t2.composedPath()[0];
      s5 !== this.host && (t2.stopPropagation(), this.addCallback(t2.callback, s5, t2.subscribe));
    }, this.onProviderRequest = (s5) => {
      if (s5.context !== this.context) return;
      if ((s5.contextTarget ?? s5.composedPath()[0]) === this.host) return;
      const e4 = /* @__PURE__ */ new Set();
      for (const [s6, { consumerHost: i3 }] of this.subscriptions) e4.has(s6) || (e4.add(s6), i3.dispatchEvent(new s(this.context, i3, s6, true)));
      s5.stopPropagation();
    }, this.host = s4, void 0 !== e3.context ? this.context = e3.context : this.context = e3, this.attachListeners(), this.host.addController?.(this);
  }
  attachListeners() {
    this.host.addEventListener("context-request", this.onContextRequest), this.host.addEventListener("context-provider", this.onProviderRequest);
  }
  hostConnected() {
    this.host.dispatchEvent(new e(this.context, this.host));
  }
};

// node_modules/.pnpm/@lit+context@1.1.6/node_modules/@lit/context/lib/context-root.js
var t = class {
  constructor() {
    this.pendingContextRequests = /* @__PURE__ */ new Map(), this.onContextProvider = (t2) => {
      const s4 = this.pendingContextRequests.get(t2.context);
      if (void 0 === s4) return;
      this.pendingContextRequests.delete(t2.context);
      const { requests: o } = s4;
      for (const { elementRef: s5, callbackRef: n2 } of o) {
        const o2 = s5.deref(), c2 = n2.deref();
        void 0 === o2 || void 0 === c2 || o2.dispatchEvent(new s(t2.context, o2, c2, true));
      }
    }, this.onContextRequest = (e3) => {
      if (true !== e3.subscribe) return;
      const t2 = e3.contextTarget ?? e3.composedPath()[0], s4 = e3.callback;
      let o = this.pendingContextRequests.get(e3.context);
      void 0 === o && this.pendingContextRequests.set(e3.context, o = { callbacks: /* @__PURE__ */ new WeakMap(), requests: [] });
      let n2 = o.callbacks.get(t2);
      void 0 === n2 && o.callbacks.set(t2, n2 = /* @__PURE__ */ new WeakSet()), n2.has(s4) || (n2.add(s4), o.requests.push({ elementRef: new WeakRef(t2), callbackRef: new WeakRef(s4) }));
    };
  }
  attach(e3) {
    e3.addEventListener("context-request", this.onContextRequest), e3.addEventListener("context-provider", this.onContextProvider);
  }
  detach(e3) {
    e3.removeEventListener("context-request", this.onContextRequest), e3.removeEventListener("context-provider", this.onContextProvider);
  }
};

// src/components/jb-heading/heading-context.ts
var DEFAULT_HEADING_LEVEL = 2;
var headingLevelContext = n(/* @__PURE__ */ Symbol("jb-heading-level"));
new t().attach(document.documentElement);
function clampHeadingLevel(level) {
  if (level === void 0 || Number.isNaN(level)) {
    return DEFAULT_HEADING_LEVEL;
  }
  return Math.min(Math.max(level, 1), 6);
}

export {
  s2 as s,
  i,
  DEFAULT_HEADING_LEVEL,
  headingLevelContext,
  clampHeadingLevel
};
/*! Bundled license information:

@lit/context/lib/context-request-event.js:
@lit/context/lib/create-context.js:
@lit/context/lib/controllers/context-consumer.js:
@lit/context/lib/value-notifier.js:
@lit/context/lib/controllers/context-provider.js:
@lit/context/lib/context-root.js:
  (**
   * @license
   * Copyright 2021 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/context/lib/decorators/provide.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/context/lib/decorators/consume.js:
  (**
   * @license
   * Copyright 2022 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)
*/
